const savingsCalculator = () => {
    document.addEventListener('DOMContentLoaded', function() {
        const rangeSlider = document.getElementById('myRange');
        if (!rangeSlider) return;
        const costValueDisplay = document.querySelector('.cost-value');
        const savingsDisplay = document.querySelector('.cost-savings');

        function linearInterpolation(x1, y1, x2, y2, x) {
            return y1 + (x - x1) * (y2 - y1) / (x2 - x1);
        }

        function calculateSavings(monthlyBill) {
            if (monthlyBill <= 100) {
                return linearInterpolation(30, 11100, 100, 22950, monthlyBill);
            } else if (monthlyBill <= 200) {
                return linearInterpolation(100, 22950, 200, 40500, monthlyBill);
            } else {
                let rate = (40500 - 22950) / (200 - 100);
                return 40500 + rate * (monthlyBill - 200);
            }
        }

        function getElectricityCost(monthlyBill) {
            if (monthlyBill <= 100) {
                return {
                    withoutSolar: linearInterpolation(30, 8100, 100, 27000, monthlyBill),
                    withSolar: linearInterpolation(30, -3000, 100, 4050, monthlyBill)
                };
            } else {
                return {
                    withoutSolar: linearInterpolation(100, 27000, 200, 54000, monthlyBill),
                    withSolar: linearInterpolation(100, 4050, 200, 13500, monthlyBill)
                };
            }
        }

        function formatAsMoney(value) {
            return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                maximumFractionDigits: 0
            }).format(value);
        }

        function updateGraph(monthlyBill) {
            const costs = getElectricityCost(monthlyBill);
            document.querySelector('.cost-without-solar').textContent = formatAsMoney(costs.withoutSolar);
            document.querySelector('.cost-with-solar').textContent = formatAsMoney(costs.withSolar);

            // Determine the height for bars
            let percentageWithoutSolar, percentageWithSolar;
            if (monthlyBill === 100) {
                percentageWithoutSolar = 54;
                percentageWithSolar = 8.1;
            } else if (monthlyBill === 200) {
                percentageWithoutSolar = 108;
                percentageWithSolar = 27;
            } else if (monthlyBill === 30) {
                percentageWithoutSolar = 16.2;
                percentageWithSolar = 0;
            } else {
                // Interpolate for other values
                if (monthlyBill < 100) {
                    percentageWithoutSolar = linearInterpolation(30, 16.2, 100, 54, monthlyBill);
                    percentageWithSolar = linearInterpolation(30, 0, 100, 8.1, monthlyBill);
                } else {
                    percentageWithoutSolar = linearInterpolation(100, 54, 200, 108, monthlyBill);
                    percentageWithSolar = linearInterpolation(100, 8.1, 200, 27, monthlyBill);
                }
            }

            // List of year multipliers to adjust bar heights
            const yearFactors = [3/15, 6/15, 9/15, 12/15, 1]; // '1' for 15 years

            // Iterate through each year factor and update the bar heights
            yearFactors.forEach((factor, index) => {
                const barContainers = document.querySelectorAll(`.bar-container`);
                const greyBar = barContainers[index].querySelector('.bar-grey');
                const greenBar = barContainers[index].querySelector('.bar-green');

                greyBar.style.height = (percentageWithoutSolar * factor) + "%";
                greenBar.style.height = (percentageWithSolar * factor) + "%";
            });
        }

        rangeSlider.addEventListener('input', () => {
            const monthlyBill = parseFloat(rangeSlider.value);
            costValueDisplay.textContent = formatAsMoney(monthlyBill);
            const savings = calculateSavings(monthlyBill);
            savingsDisplay.textContent = formatAsMoney(savings);
            updateGraph(monthlyBill);
        });

        // Initial setups
        costValueDisplay.textContent = formatAsMoney(rangeSlider.value);
        savingsDisplay.textContent = formatAsMoney(calculateSavings(rangeSlider.value));
        updateGraph(parseFloat(rangeSlider.value));
    });
}

savingsCalculator();